<template>
	<MainContent />
</template>

<script>
export default {
	name: 'Page',
};
</script>
